import AAF from '../../AAF/AAF';
import { getPurchaseNodeId, purchaseButtonInfo } from "../../requests/loader";
import store from '../../store';

const flowIsAfterLoginAdsExperience = (history, urlRedirect) => {
  if (AAF.AdsUtils.isAfterLogin()) {
    let { ads: {
      propsAfterLogin: {
        stateAL: {
          product_id = '',
          oneoffertype = '',
          producttype = '',
          groupId = '',
          type = "",
          offerid = '',
        } = {}
        } = {}
      } = {},
      navbar: { nodes } = {} } = store.getState() || {};

    const typeValidation = AAF.AdsUtils.contentType(oneoffertype, producttype, type);

    if (typeValidation === 'rent' || typeValidation === 'buy') {
      purchaseButtonInfo(groupId).then((response) => {
        if (response && response.downloadButton && response.downloadButton.waspurchased && parseInt(response.downloadButton.waspurchased) === 1) {
          AAF.AdsUtils.findNodeToRedirect(history, nodes, '', oneoffertype, producttype, groupId);
        }
        else {
          AAF.AdsUtils.redirectToRoot(history, false);
        }
      }).catch(() => {
        AAF.AdsUtils.redirectToRoot(history, false);
      });
    } else {
      getPurchaseNodeId(Number(product_id)).then((response) => {
        const { node_id = '' } = response;
        AAF.AdsUtils.findNodeToRedirect(history, nodes, node_id, oneoffertype, producttype, groupId);
      }).catch(() => {
        AAF.AdsUtils.redirectToRoot(history, false);
      });
    }
  } else {
    history.push(urlRedirect);
  }
};

const profileUtils = {
  flowIsAfterLoginAdsExperience,
}

export default profileUtils;



// WEBPACK FOOTER //
// ./src/containers/Profile/utils.js